import { Component, createNgModule, Inject, Injector, NgModuleRef, PLATFORM_ID, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { priceValidator } from '../deposit/amount.validator';
import { BasePageComponentWithDialogs } from '../../base-page/base-page.component';
import { map, switchMap, takeUntil } from 'rxjs/operators';
import { BalanceStatusService } from 'src/app/services/wallet/balance-status.service';
import { WithdrawalService } from 'src/app/services/payment/withdrawal/withdrawal.service';
import { ExternalPaymentResponse, WithdrawalMethod } from 'src/app/services/payment/methods/methods.models';
import { MatDialog } from '@angular/material/dialog';
import { LoaderService } from 'src/app/services/utils/loader/loader.service';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import {
  PAYMENT_METHOD_PROVIDER_BACKOFFICE,
  PAYMENT_METHOD_PROVIDER_PAYMENTIQ,
  PaymentListService
} from 'src/app/services/payment/methods/payment-list.service';
import { PaymentIqService } from 'src/app/services/payment/methods/paymentiq.service';
import { DELETE_CARD_WARNING } from '../deposit/main-deposit/main-deposit.component';
import { UserInfoService } from 'src/app/services/auth/check-session/user-info.service';
import { uploadDocumentsTrx } from 'src/app/router-translation.labels';
import { MinimizeSiteService } from 'src/app/services/utils/hide-footer.service';
import { SafeHtml } from '@angular/platform-browser';
import { isPlatformServer } from '@angular/common';
import { UserFullInfoService } from 'src/app/services/auth/check-session/user-full-info.service';

@Component({
  selector: 'app-withdrawal',
  templateUrl: './withdrawal.component.html',
  styleUrls: ['./withdrawal.component.scss']
})
export class WithdrawalComponent extends BasePageComponentWithDialogs {

  withdrawalForm = this.createForm()

  minimum: number;
  maximum: number;
  fee: number;
  balance: number;
  currency: string
  formSubmitted: boolean = false;
  selectedMethod: WithdrawalMethod;
  isBlockFormSubmition: boolean = false;
  isReady: boolean = false;
  description: SafeHtml;

  isFilled = false;
  checkDocumentsTitle: string = $localize`:@@withdrawalDocumentTitle: Withdrawal request`;
  checkDocumentsMsg: string = $localize`:@@withdrawalDocumentMsg: Thanks for requesting a withdrawal! We just wanted to remind you that we need to verify your account before we can process the withdrawal. To avoid any delays, we recommend uploading the necessary documents directly on our website.`;

  showAddBankAccount: boolean = false;
  selectedMethodInfo: any;
  isComponentReady: boolean = false;
  successMsg: string = $localize`:@@withdrawalSUccessMsg:Your withdrawal was successfully accepted for confirmation. After verifying all the details, your account will be credited. You can always review its status in pending withdrawals section. `;
  redirectMsg: string = $localize`:@@withdrawalSUccessMsg:You are being redirected to confirm your withdrawal.`;
  nonStickyBonus: boolean | null = null;
  non_sticky_bonus_warning: string = $localize`:@@withdrawalBonusMsg:Bonus money will disappear`;
  selectPayment: boolean = false;
  paymentList: WithdrawalMethod[];
  isAccountSelected: boolean = false;
  prevFormValues: any[] = [];
  showPaymentiq: boolean = false;
  cryptoSelectedValue: any;
  currentBalance: number = 0;
  balanceErrorMsg: string = $localize`:@@withdrawalbalanceErrorMsg:There are not enough funds in this wallet`;


  private _paymentiqRef: ViewContainerRef;
  private paymentIqComponentInstance: any;
  isBlockedWithdrawals: boolean;

  @ViewChild('paymentiq', { static: false, read: ViewContainerRef })
  set paymentiqRef(ref: ViewContainerRef) {
    this._paymentiqRef = ref;
    if (ref) {
      if (!isPlatformServer(this.platformId)) {
        import('../../../modules/paymentiq-additional-fields/paymentiq-additional-fields.module').then((importedFile) => {
          const componentToOpen =
            importedFile.PaymentiqAdditionalFieldsDynamicModule.components.dynamicComponent;
          this._openLazyLoadedPaymentIqComponent(importedFile, componentToOpen);
        });
      }
    }
  }

  get paymentiqRef(): ViewContainerRef {
    return this._paymentiqRef;
  }

  protected isShowPaymentIqModulePlaceholder = true;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private ballanceStatusService: BalanceStatusService,
    private withdrawalService: WithdrawalService,
    private userFullInfoService: UserFullInfoService,
    private loaderService: LoaderService,
    private paymentListService: PaymentListService,
    private paymentIqService: PaymentIqService,
    private balanceService: BalanceStatusService,
    dialog: MatDialog,
    public detectDeviceService: DetectDeviceService,
    private infoService: UserInfoService,
    private minimizeFotterService: MinimizeSiteService,
    @Inject(PLATFORM_ID) public platformId: string,
    private _injector: Injector,
  ) { super(dialog, detectDeviceService) }

  createForm() {
    return this.formBuilder.group({
      amount: ['', []],
      payment_id: ['2', [Validators.required]],
    });
  }

  clearFormFields() {
    for (let value in this.withdrawalForm.value) {
      if (!['amount', 'payment_id'].includes(value)) {

        let field = this.withdrawalForm.get(value);
        if (field.value) {
          let existKey = this.prevFormValues.find((item) => {
            return Object.keys(item)[0] == value
          });
          if (existKey) {
            this.prevFormValues.splice(this.prevFormValues.indexOf(existKey), 1, { [value]: field.value });
          } else {
            this.prevFormValues.push({ [value]: field.value });
          }
        }
        this.withdrawalForm.removeControl(value);
      }
    }
  }

  ngOnInit(): void {
    // this.minimizeFotterService.minimizeToolbar();
    this.isDesktop = this.detectDeviceService.isDesktop();
    this.loaderService.show();
    this.paymentListService.fetchWithdrawals().pipe(takeUntil(this.unsubscribe)).subscribe({
      next: (resp) => {
        this.paymentList = resp;
        this.isReady = true;
        this.loaderService.hide();

        if (resp && resp.length > 0) {
          this.selectPaymentMethod(resp[0])
        }
      },
      error: (error) => {
        if (error?.error?.error === 'Your withdrawal has been blocked.') {
          this.isBlockedWithdrawals = true;
        }
        this.isReady = true;
        this.loaderService.hide();
      },

    })

    this.ballanceStatusService.getBalanceInfoStatus().pipe(takeUntil(this.unsubscribe)).subscribe(resp => {
      this.currency = resp.currency;
      this.balance = resp.balance;
    },
      (error) => {

      },
      () => {
      }
    )

    this.balanceService.getBalanceInfoStatus()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(balanceResp => {
        this.currentBalance = balanceResp.balance;
        this.nonStickyBonus = balanceResp.non_sticky_bonus;
      });

    this.userFullInfoService.requestFullInfo(true).pipe(takeUntil(this.unsubscribe)).subscribe({
      next: (res) => {
        this.isFilled = res.required_documents.length > 0 ? false : true;
      },
      error: () => { },
      complete: () => { },
    })
  }

  selectPaymentMethod(method: WithdrawalMethod) {
    this.selectPayment = false;
    this.loaderService.show();
    this.isBlockFormSubmition = true;
    this.showAddBankAccount = false;
    this.selectedMethod = method;
    console.log('selectedMethoddesk', this.selectedMethod?.description);
    this.description = null;

    if (method?.description) {
      this.description = method?.description["changingThisBreaksApplicationSecurity"] === "<p></p>" ? null : method.description;
    }

    this.clearFormFields();
    const validators = [Validators.required, priceValidator(method.limits.minimum, method.limits.maximum)]
    this.withdrawalForm.get('amount').clearValidators();
    this.withdrawalForm.get('amount').setValidators(validators);
    // this.withdrawalForm.get('amount').setValue(currentAmount);
    this.maximum = method.limits.maximum ? method.limits.maximum : this.balance;
    this.minimum = method.limits.minimum || 0;
    this.fee = method.fee?.value || 0;

    if (method.paymentMethodProvider === PAYMENT_METHOD_PROVIDER_BACKOFFICE) {


      this.withdrawalService.getFields(method.pk).pipe(takeUntil(this.unsubscribe)).subscribe(resp => {
        this.isBlockFormSubmition = false;
        this.selectedMethodInfo = resp;
        this.withdrawalForm.get('payment_id').setValue(method.pk)
        this.showAddBankAccount = true;
        this.isComponentReady = true;

        this.prevFormValues.forEach((value) => {
          const key = Object.keys(value)[0];
          let field1 = this.selectedMethodInfo.fields.find((field) => field.name === key);

          if (field1) {
            field1.value = value[key];
          }
        });
      },
        error => {
          this.loaderService.hide();
          this.isBlockFormSubmition = false;
          this.isComponentReady = true;
        },
        () => {
          this.loaderService.hide();
        }
      )
    } else if (method.paymentMethodProvider === PAYMENT_METHOD_PROVIDER_PAYMENTIQ) {
      this.isBlockFormSubmition = false;
      this.isAccountSelected = method.paymentIqAccounts?.length > 0 ? true : false;
      this.selectedMethodInfo = method;
      // this.showPaymentiq = (this.selectedMethodInfo?.paymentIqAccounts?.length > 0) || (this.selectedMethodInfo?.addPaymentIqHostedFields) ? true : false;
      this.showPaymentiq = true;
      this.withdrawalForm.get('payment_id').setValue(method.pk)
      this.showAddBankAccount = false;
      this.isComponentReady = true;
      this.loaderService.hide();

      if (!!method.paymentIqAdditionalFields && !this.isAccountSelected) {
        method.paymentIqAdditionalFields.forEach(element => {
          this.withdrawalForm.addControl(element.name, new UntypedFormControl(!!element.value ? element.value : "", element.type !== 'select' ? Validators.required : undefined));

          if (element.selections && element.selections.length > 0) {
            this.withdrawalForm.get(element.name).setValue(element.selections[0].value);
          }
        });
      }
    }
    this.selectedMethod.paymentIqAdditionalFields?.forEach((cryptoFieldValue: any) => {
      if (cryptoFieldValue.selections) {
        this.cryptoSelectedValue = cryptoFieldValue.selections[0].name;
      }
      else if (cryptoFieldValue.choices) {
        this.cryptoSelectedValue = cryptoFieldValue.choices[0]?.display_name;
      }
    })
  }

  clickableCryptoValue(value: any) {
    this.cryptoSelectedValue = value;
  }

  confirm(accountToDelete: string) {
    this.paymentIqComponentInstance.confirmAccountDelete()
  }

  onAccountDeleteAttempt(accountToDelete: string) {
    this.openConfirmDialog(DELETE_CARD_WARNING, accountToDelete, () => this.confirm);
  }

  documentsRedirect = () => {

  }

  onPaymentIqAccountSelect(isSelected: boolean) {
    this.isAccountSelected = isSelected;
    this.selectPaymentMethod(this.selectedMethod);
  }

  onSubmit(withdrawalForm) {



    if (!this.withdrawalForm.valid) {
      for (let i in this.withdrawalForm.controls) {
        if (withdrawalForm.controls[i].invalid) {
          console.log('invalid', i);
        }
        this.withdrawalForm.controls[i].markAsTouched()
      }
      return false
    }
    if (!this.withdrawalForm.valid || this.formSubmitted) return;
    this.formSubmitted = true;

    if (this.nonStickyBonus) {
      this.formSubmitted = false;
      this.openConfirmDialog(this.non_sticky_bonus_warning, {}, () => {
        this.formSubmitted = true;
      })
    };

    if (this.selectedMethod.paymentMethodProvider === PAYMENT_METHOD_PROVIDER_BACKOFFICE) {
      this.withdrawalService.postWithdraw(this.withdrawalForm).pipe(takeUntil(this.unsubscribe)).subscribe(
        (resp) => {
          if (!this.isFilled) {
            this.openSuccessDialog(this.checkDocumentsMsg, this.checkDocumentsTitle, this.documentsRedirect, uploadDocumentsTrx)
          }
          else if (!!resp.payment_link) {
            window.location.href = resp.payment_link;
            this.openSuccessDialog(this.redirectMsg);
          }
          else {
            this.openSuccessDialog(this.successMsg);
          }
          this.formSubmitted = false;
        },
        (error) => {
          if (error.status === 400) {
            Object.keys(error.error.errors).forEach(prop => {
              const formControl = this.withdrawalForm.get(prop);
              if (formControl) {
                formControl.setErrors({
                  serverError: error.error.errors[prop].pop()
                });
              } else {
                this.openErrorDialog(error.error.errors[prop].pop());
              }
            });
          } else {
            const errorMsg = error.error?.error || error.error?.detail
            this.openErrorDialog(errorMsg);
          }
          this.formSubmitted = false;
        }
      )
    } else if (this.selectedMethod.paymentMethodProvider === PAYMENT_METHOD_PROVIDER_PAYMENTIQ) {

      const account = this.paymentIqComponentInstance.getAccountName();
      if (!!account && account !== "") {
        this.withdrawalForm.removeControl('accountId');
        this.withdrawalForm.addControl('accountId', new UntypedFormControl(account, [Validators.required]));

      }
      this.paymentIqService.submitWithdrawal(this.withdrawalForm, this.selectedMethod).pipe(takeUntil(this.unsubscribe)).subscribe(resp => {
        const processedResp: ExternalPaymentResponse = this.paymentIqService.processWithdrawalResponse(resp);
        this.loaderService.hide();
        if (processedResp.isError) {
          if (this.currentBalance < withdrawalForm.value.amount) {
            const formControl = this.withdrawalForm.get('amount');
            if (formControl) {
              formControl.setErrors({
                serverError: this.balanceErrorMsg,
              });
            }
          }
          else {
            this.openErrorDialog(processedResp.errorMsg);
          }
          this.formSubmitted = false;
        } else {
          if (this.isFilled) {
            this.openSuccessDialog(this.successMsg);
          }
          else {
            this.openSuccessDialog(this.checkDocumentsMsg, this.checkDocumentsTitle, this.documentsRedirect, uploadDocumentsTrx)
          }
          this.formSubmitted = false;
        }
      });
    }
  }

  updatePaymentIqAccountValue(account): void {

  }

  ngOnDestroy(): void {
    this.withdrawalService.setPageTitle(true);
    super.ngOnDestroy();
  }

  private _openLazyLoadedPaymentIqComponent<T>(
    importedFile: T,
    componentToOpen: Type<any>
  ): void {
    if (!!this.paymentIqComponentInstance) return;
    this.isShowPaymentIqModulePlaceholder = false;
    const module: Type<T> = (importedFile as any)[Object.keys(importedFile)[0]];
    const moduleRef: NgModuleRef<T> = createNgModule(module, this._injector);
    const componentRef = this.paymentiqRef.createComponent(componentToOpen, { ngModuleRef: moduleRef });

    this.paymentIqComponentInstance = componentRef.instance;

    this.paymentIqComponentInstance.parentForm = this.withdrawalForm;
    this.paymentIqComponentInstance.methodInfo = this.selectedMethodInfo;
    this.paymentIqComponentInstance.isDeposit = false;

    this.paymentIqComponentInstance.accountDeleteAttempt.subscribe((event) => {
      this.onAccountDeleteAttempt(event);
    });

    const element = componentRef.location.nativeElement as HTMLElement;
    element.style.width = '95lvw';

    this.paymentIqComponentInstance.destroyed.subscribe(() => {
      this.paymentIqComponentInstance = null;
    });
  }
}
